import { Set } from '~commonInfra/utils/Set';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { createMultipleItemResultNotificationValues,MultipleItemResultNotificationValues } from '~src/commonInfra/contentActions/ActionMessages';
import { ContentActionNotification } from '~src/commonInfra/contentActions/ContentActionNotification';
import { IErrorItem, MultipleItemResult } from '~src/commonInfra/contentActions/MultipleItemResult';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IGroupSetInfo } from '../../models/IGroupSetInfo';


function notify(result: IResult, groupSets: Set<IGroupSetInfo>) {
    // create a notification object for result reporting
    const notification: MultipleItemResultNotificationValues = createMultipleItemResultNotificationValues(
        new MultipleItemResult(groupSets, result),
        {
        describeSuccessSummary: (successCount: number) => {
            if (successCount === 1) {
                return Messages.deleteGroupSetSuccess({ GROUP_SET_NAME: groupSets.first().name});
            }
            return Messages.deleteGroupSetsSuccess({ ITEM_COUNT: successCount, ITEM_COUNT_LOC: L10n.localizedCount(successCount)});
        },
        describeErrorSummary: (errorCount: number) => {
            return Messages.deleteGroupSetsError({ ERROR_COUNT: errorCount, ERROR_COUNT_LOC: L10n.localizedCount(errorCount)});
        },
        describeErrorDetail: (errorItem: IErrorItem<IGroupSetInfo>) => {
            const siteUrls = siteUrlsSelector(getAppStore().getState());
            return {
                itemName: errorItem.item.name,
                itemUrl: siteUrls.groupSetUrl(errorItem.item.id),
                errorMessage: errorMessageFor(errorItem.error, errorItem.item.name)
                };
            }
        }
    );

    // pass the notification object to the service for displaying
    ContentActionNotification.displayItemizedToastsForResult(notification);
}

function errorMessageFor(error: IError, groupName: string) {
    switch (error.code) {
        default:
            return Messages.errorUnknown();
    }
}


export const DeleteGroupSetsNotificationAction = {
    notify
};

export type DeleteGroupSetsNotificationAction = typeof DeleteGroupSetsNotificationAction;
